import React from 'react';
import { ServerCommunicationMixin } from '../mixins/shared/server_communication_mixin';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const GoogleFacebookSignup = createReactClass({
  mixins: [ServerCommunicationMixin],
  componentWillMount() {},
  componentDidMount() {
    this.initFB(this.handleFbClick);
    this.initApple();
    //   a bit of a hack to call GAPI attachment in React on load
    window.handleGoogleClientLoad = function() {
      this.initGoogle(this.googleSuccessCallback);
    }.bind(this);
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js?onload=handleGoogleClientLoad';
    script.async = true;
    document.body.appendChild(script);
  },
  handleFbClick() {
    if (!(this.props.submitInProgress || this.props.submitSuccess)) {
      if (window.navigator && window.navigator.userAgent.match('CriOS')) {
        const redirect_uri = `${window.location.protocol}//${window.location.hostname}/users/auth/fbcrios`;
        window.open(
          `https://www.facebook.com/dialog/oauth?client_id=18128749820&redirect_uri=${redirect_uri}&scope=email,user_friends,user_gender,user_birthday,user_location`,
          '',
          null
        );
      } else {
        FB.login(
          function(response) {
            if (response.authResponse) {
              const auth = response.authResponse;
              this.setState({ submitInProgress: true });
              const fbData = {
                facebook_id: auth.userID,
                facebook_token: auth.accessToken,
                facebook_expires: auth.expiresIn,
                create_session: true,
                track_optimizely: this.props.trackOptimizely
              };
              this.setState({ submitInProgress: true });
              let headers = {};
              if (this.props.locale) {
                headers = { 'X-Language-Locale': this.props.locale };
              }
              this.postApiEndpoint(
                '/api/alltrails/facebook/login',
                fbData,
                this.props.registerSuccessCallback,
                this.props.fbRegisterErrorCallback,
                this.props.registerCompleteCallback,
                headers
              );
            }
          }.bind(this),
          { scope: 'email,user_friends,user_gender,user_birthday,user_location' }
        );
      }
    }
  },
  googleSuccessCallback(googleUser) {
    const token = googleUser.getAuthResponse().id_token;
    const data = { google_token: token, create_session: true };
    let headers = {};
    if (this.props.locale) {
      headers = { 'X-Language-Locale': this.props.locale };
    }
    this.postApiEndpoint(
      '/api/alltrails/google/login',
      data,
      this.props.registerSuccessCallback,
      this.props.registerErrorCallback,
      this.props.registerCompleteCallback,
      headers
    );
  },
  render() {
    return (
      <div>
        <div className="fb-reg">
          <div className="fb btn-container">
            <a className="flat-fb-btn" href="#">
              <div>
                <span>{StringConstantsMixin.strings.SIGNUP.CONTINUE_WITH_FB}</span>
              </div>
            </a>
          </div>
          <div id="googleSignInBtn" className="google btn-container">
            <a className="flat-fb-btn" href="#">
              <div>
                <span>{StringConstantsMixin.strings.SIGNUP.CONTINUE_WITH_GOOGLE}</span>
              </div>
            </a>
          </div>
          <div id="appleSignInBtn" className="apple btn-container">
            <a className="flat-apple-btn" href="#">
              <div>
                <span>{StringConstantsMixin.strings.SIGNUP.CONTINUE_WITH_APPLE}</span>
              </div>
            </a>
          </div>
        </div>
        <div className="or-container">
          <h2 className="or-rule">
            <span>{StringConstantsMixin.strings.OR}</span>
          </h2>
        </div>
      </div>
    );
  }
});

export { GoogleFacebookSignup };
